<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-container">
      <!-- HEADER -->
      <div class="modal-header">
        <h2>Chi tiết đơn hàng</h2>
        <button @click="$emit('close')">✖</button>
      </div>

      <!-- BODY -->
      <div class="modal-body" v-if="invoice">
        <!-- Thông tin chung -->
        <div class="info-grid">
          <div><strong>Mã đơn:</strong> {{ invoice.ma_hoa_don }}</div>
          <div><strong>Khách hàng:</strong> {{ invoice.ten_khach_hang }}</div>
          <div><strong>Điện thoại:</strong> {{ invoice.dien_thoai }}</div>
          <div>
            <strong>Ngày tạo:</strong> {{ formatDate(invoice.thoi_gian) }}
          </div>
          <div>
            <strong>Trạng thái:</strong>
            <span :class="['status', displayStatus(invoice.trang_thai).class]">
              {{ displayStatus(invoice.trang_thai).text }}
            </span>
          </div>
        </div>

        <!-- Danh sách sản phẩm -->
        <table class="product-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Tên SP</th>
              <th>Số lượng</th>
              <th>Giá</th>
              <th>Thành tiền</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, index) in invoice.items" :key="index">
              <td>{{ index + 1 }}</td>
              <td>
                <div class="product-name">
                  {{ item.ten_hang }}
                </div>
                <div class="product-imei"> {{ item.imei ? `Số IMEI: ${item.imei}` : "" }}</div>
                <div class="product-warranty-period">Thời gian bảo hành: {{ item.bao_hanh }}</div>
                <div class="product-notes"> {{ item.ghi_chu_hang_hoa ? `Ghi chú: ${item.ghi_chu_hang_hoa}` : "" }}</div>


              </td>
              <td>x 1</td>
              <td>{{ formatCurrency(item.gia_ban) }}</td>
              <td>{{ formatCurrency(1 * item.gia_ban) }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Tổng tiền -->
        <div class="total-box">
          <div>
            Tổng tiền:
            <strong>{{ formatCurrency(invoice.tong_tien_hang) }}</strong>
          </div>
          <div>Giảm giá: {{ formatCurrency(invoice.giam_gia_hoa_don) }}</div>
          <div class="final">
            Thanh toán:
            <strong>{{ formatCurrency(invoice.khach_can_tra) }}</strong>
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="modal-footer">
        <button @click="$emit('close')">Đóng</button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { formatCurrency, formatDate } from "@/utils/helpers";
import { toRefs } from "vue";
const props = defineProps({
  invoice: {
    type: Object,
    required: true,
  },
});
const { invoice } = toRefs(props);

const statusClasses = {
  "Hoàn thành": "completed",
  "Chờ xử lý" : "pending",
  "Đã hủy": "canceled",
};
const displayStatus = (status) => {
  return {
    text: status,
    class: statusClasses[status] || "",
  };
};
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  width: 800px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}

.modal-header,
.modal-footer {
  padding: 12px 16px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
}

.modal-body {
  padding: 16px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  margin-bottom: 16px;
}

.product-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 16px;
}

.product-table th,
.product-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.total-box {
  text-align: right;
}

.total-box .final {
  font-size: 18px;
  color: red;
}

.status {
  padding: 4px 8px;
  border-radius: 5px;
  margin-left: 8px;
}

.status.completed {
  background: #d4edda;
  color: green;
}

.status.pending {
  background: #fff3cd;
  color: orange;
}

.product-name {
  display: block;
  font-weight: 500;
  color: #1a202c; /* Màu đen đậm cho tên hàng */
}

.product-imei, .product-notes, .product-warranty-period {
  display: block;
  font-size: 0.75rem; /* Chữ nhỏ hơn */
  color: #718096; /* Màu xám nhạt */
  margin-top: 2px;
}

</style>
